const SUPABASE_URL = 'https://hhxtmjdzcnnyqvlckfki.supabase.co';
const SUPABASE_ANON_KEY = 'sb_publishable_NQSZ9IngUGI_o9uAFTppoA_o7PEXxV7';
const SESSION_STORAGE_KEY = 'bitbyte.supabase.session';

const authFetch = async (path, {method = 'GET', token, body} = {}) => {
    const headers = {
        apikey: SUPABASE_ANON_KEY,
        'Content-Type': 'application/json'
    };

    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    const response = await fetch(`${SUPABASE_URL}${path}`, {
        method,
        headers,
        body: body ? JSON.stringify(body) : undefined
    });

    const text = await response.text();
    let payload = null;
    try {
        payload = text ? JSON.parse(text) : null;
    } catch (error) {
        payload = text;
    }

    if (!response.ok) {
        const message = payload && typeof payload === 'object' && (payload.msg || payload.message || payload.error_description || payload.error)
            ? (payload.msg || payload.message || payload.error_description || payload.error)
            : (typeof payload === 'string' && payload ? payload : `Request failed with status ${response.status}`);
        throw new Error(message);
    }

    return payload;
};

const getStoredSession = () => {
    if (typeof window === 'undefined') return null;
    try {
        const raw = window.localStorage.getItem(SESSION_STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (error) {
        return null;
    }
};

const setStoredSession = session => {
    if (typeof window === 'undefined') return;
    if (!session) {
        window.localStorage.removeItem(SESSION_STORAGE_KEY);
        return;
    }
    window.localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(session));
};

const clearStoredSession = () => setStoredSession(null);

const signUp = async ({name, email, password, username}) => {
    const data = await authFetch('/auth/v1/signup', {
        method: 'POST',
        body: {
            email,
            password,
            data: {
                name,
                username,
                credits: 200
            }
        }
    });

    return data;
};

const signIn = async ({email, password}) => authFetch('/auth/v1/token?grant_type=password', {
    method: 'POST',
    body: {
        email,
        password
    }
});

const getUser = async accessToken => authFetch('/auth/v1/user', {
    method: 'GET',
    token: accessToken
});

const updateUser = async (accessToken, data) => authFetch('/auth/v1/user', {
    method: 'PUT',
    token: accessToken,
    body: {
        data
    }
});

const signOut = async accessToken => {
    try {
        await authFetch('/auth/v1/logout?scope=global', {
            method: 'POST',
            token: accessToken
        });
    } catch (error) {
        // Ignore sign-out failures and clear local state anyway.
    }
    clearStoredSession();
};

export {
    SUPABASE_URL,
    SUPABASE_ANON_KEY,
    SESSION_STORAGE_KEY,
    authFetch,
    clearStoredSession,
    getStoredSession,
    getUser,
    setStoredSession,
    signIn,
    signOut,
    signUp,
    updateUser
};
